import '../../assets/index55.css';var K = Object.defineProperty, W = Object.defineProperties;
var G = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var V = Object.prototype.hasOwnProperty, j = Object.prototype.propertyIsEnumerable;
var E = (t, e, r) => e in t ? K(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, m = (t, e) => {
  for (var r in e || (e = {}))
    V.call(e, r) && E(t, r, e[r]);
  if ($)
    for (var r of $(e))
      j.call(e, r) && E(t, r, e[r]);
  return t;
}, b = (t, e) => W(t, G(e));
var _ = (t, e) => {
  var r = {};
  for (var s in t)
    V.call(t, s) && e.indexOf(s) < 0 && (r[s] = t[s]);
  if (t != null && $)
    for (var s of $(t))
      e.indexOf(s) < 0 && j.call(t, s) && (r[s] = t[s]);
  return r;
};
import { jsx as i, jsxs as D } from "react/jsx-runtime";
import { useState as U, useEffect as X, forwardRef as J } from "react";
import { Button as H } from "../Button/index.js";
import { Title as L } from "../Title/index.js";
import { XMarkFarFAIcon as Q } from "../Icons/index.js";
import { g as A } from "../../OptionalPortal-sP4Hf4UO.js";
import { f as g, u as x } from "../../factory-ueRxoNOV.js";
import { M as Y, a as ee, N as te, b as re, c as se, d as oe, e as ae, f as ne } from "../../NativeScrollArea-AK71H4_N.js";
import { c as le } from "../../create-safe-context-DqDyoPVE.js";
import { r as ce } from "../../rem-CMQJ_ZTp.js";
import { c as de } from "../../get-size-Bc1Pz5yf.js";
import { c as ie } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as me } from "../../use-styles-DToiHEa6.js";
import { u as ue } from "../../DirectionProvider-CT8S13Cp.js";
import { S as pe } from "../../ScrollArea-BFbb1tLv.js";
import { c as fe } from "../../create-optional-context-CQ2ahjKQ.js";
import { S as we } from "../../Stack-CTaaXTID.js";
const [ye, k] = le(
  "Drawer component was not found in tree"
);
var v = { root: "m_f11b401e", header: "m_5a7c2c9", content: "m_b8a05bbd", inner: "m_31cd769a" };
const he = {}, M = g((t, e) => {
  const c = x("DrawerBody", he, t), { classNames: s, className: u, style: a, styles: n, vars: p } = c, l = _(c, ["classNames", "className", "style", "styles", "vars"]), o = k();
  return /* @__PURE__ */ i(
    Y,
    m(m({
      ref: e
    }, o.getStyles("body", { classNames: s, style: a, styles: n, className: u })), l)
  );
});
M.classes = v;
M.displayName = "@mantine/core/DrawerBody";
const _e = {}, O = g((t, e) => {
  const c = x("DrawerCloseButton", _e, t), { classNames: s, className: u, style: a, styles: n, vars: p } = c, l = _(c, ["classNames", "className", "style", "styles", "vars"]), o = k();
  return /* @__PURE__ */ i(
    ee,
    m(m({
      ref: e
    }, o.getStyles("close", { classNames: s, style: a, styles: n, className: u })), l)
  );
});
O.classes = v;
O.displayName = "@mantine/core/DrawerCloseButton";
const ve = {}, z = g((t, e) => {
  const N = x("DrawerContent", ve, t), { classNames: s, className: u, style: a, styles: n, vars: p, children: l, radius: o, __hidden: c } = N, y = _(N, ["classNames", "className", "style", "styles", "vars", "children", "radius", "__hidden"]), d = k(), S = d.scrollAreaComponent || te;
  return /* @__PURE__ */ i(
    re,
    b(m(b(m({}, d.getStyles("content", { className: u, style: a, styles: n, classNames: s })), {
      innerProps: d.getStyles("inner", { className: u, style: a, styles: n, classNames: s }),
      ref: e
    }), y), {
      radius: o || d.radius || 0,
      "data-hidden": c || void 0,
      children: /* @__PURE__ */ i(S, { style: { height: "calc(100vh - var(--drawer-offset) * 2)" }, children: l })
    })
  );
});
z.classes = v;
z.displayName = "@mantine/core/DrawerContent";
const De = {}, F = g((t, e) => {
  const c = x("DrawerHeader", De, t), { classNames: s, className: u, style: a, styles: n, vars: p } = c, l = _(c, ["classNames", "className", "style", "styles", "vars"]), o = k();
  return /* @__PURE__ */ i(
    se,
    m(m({
      ref: e
    }, o.getStyles("header", { classNames: s, style: a, styles: n, className: u })), l)
  );
});
F.classes = v;
F.displayName = "@mantine/core/DrawerHeader";
const ge = {}, R = g((t, e) => {
  const c = x("DrawerOverlay", ge, t), { classNames: s, className: u, style: a, styles: n, vars: p } = c, l = _(c, ["classNames", "className", "style", "styles", "vars"]), o = k();
  return /* @__PURE__ */ i(
    oe,
    m(m({
      ref: e
    }, o.getStyles("overlay", { classNames: s, style: a, styles: n, className: u })), l)
  );
});
R.classes = v;
R.displayName = "@mantine/core/DrawerOverlay";
function xe(t) {
  switch (t) {
    case "top":
      return "flex-start";
    case "bottom":
      return "flex-end";
    default:
      return;
  }
}
function Se(t) {
  if (t === "top" || t === "bottom")
    return "0 0 calc(100% - var(--drawer-offset, 0rem) * 2)";
}
const Ne = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
}, Be = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
}, Ce = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: A("modal"),
  position: "left"
}, be = ie((t, { position: e, size: r, offset: s }) => ({
  root: {
    "--drawer-size": de(r, "drawer-size"),
    "--drawer-flex": Se(e),
    "--drawer-height": e === "left" || e === "right" ? void 0 : "var(--drawer-size)",
    "--drawer-align": xe(e),
    "--drawer-justify": e === "right" ? "flex-end" : void 0,
    "--drawer-offset": ce(s)
  }
})), Z = g((t, e) => {
  const r = x("DrawerRoot", Ce, t), P = r, {
    classNames: s,
    className: u,
    style: a,
    styles: n,
    unstyled: p,
    vars: l,
    scrollAreaComponent: o,
    position: c,
    transitionProps: y,
    radius: d
  } = P, S = _(P, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "scrollAreaComponent",
    "position",
    "transitionProps",
    "radius"
  ]), { dir: N } = ue(), B = me({
    name: "Drawer",
    classes: v,
    props: r,
    className: u,
    style: a,
    classNames: s,
    styles: n,
    unstyled: p,
    vars: l,
    varsResolver: be
  }), C = (N === "rtl" ? Be : Ne)[c];
  return /* @__PURE__ */ i(ye, { value: { scrollAreaComponent: o, getStyles: B, radius: d }, children: /* @__PURE__ */ i(
    ae,
    m(b(m({
      ref: e
    }, B("root")), {
      transitionProps: m({ transition: C }, y),
      "data-offset-scrollbars": o === pe.Autosize || void 0,
      unstyled: p
    }), S)
  ) });
});
Z.classes = v;
Z.displayName = "@mantine/core/DrawerRoot";
const [ke, Pe] = fe();
function q({ children: t }) {
  const [e, r] = U([]), [s, u] = U(A("modal"));
  return /* @__PURE__ */ i(
    ke,
    {
      value: {
        stack: e,
        addModal: (a, n) => {
          r((p) => [.../* @__PURE__ */ new Set([...p, a])]), u(
            (p) => typeof n == "number" && typeof p == "number" ? Math.max(p, n) : p
          );
        },
        removeModal: (a) => r((n) => n.filter((p) => p !== a)),
        getZIndex: (a) => `calc(${s} + ${e.indexOf(a)} + 1)`,
        currentId: e[e.length - 1],
        maxZIndex: s
      },
      children: t
    }
  );
}
q.displayName = "@mantine/core/DrawerStack";
const Ie = {}, T = g((t, e) => {
  const c = x("DrawerTitle", Ie, t), { classNames: s, className: u, style: a, styles: n, vars: p } = c, l = _(c, ["classNames", "className", "style", "styles", "vars"]), o = k();
  return /* @__PURE__ */ i(
    ne,
    m(m({
      ref: e
    }, o.getStyles("title", { classNames: s, style: a, styles: n, className: u })), l)
  );
});
T.classes = v;
T.displayName = "@mantine/core/DrawerTitle";
const $e = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: A("modal"),
  withOverlay: !0,
  withCloseButton: !0
}, h = g((t, e) => {
  const C = x("Drawer", $e, t), {
    title: r,
    withOverlay: s,
    overlayProps: u,
    withCloseButton: a,
    closeButtonProps: n,
    children: p,
    opened: l,
    stackId: o,
    zIndex: c
  } = C, y = _(C, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children",
    "opened",
    "stackId",
    "zIndex"
  ]), d = Pe(), S = !!r || a, N = d && o ? {
    closeOnEscape: d.currentId === o,
    trapFocus: d.currentId === o,
    zIndex: d.getZIndex(o)
  } : {}, B = s === !1 ? !1 : o && d ? d.currentId === o : l;
  return X(() => {
    d && o && (l ? d.addModal(o, c || A("modal")) : d.removeModal(o));
  }, [l, o, c]), /* @__PURE__ */ D(
    Z,
    b(m(m({
      ref: e,
      opened: l,
      zIndex: d && o ? d.getZIndex(o) : c
    }, y), N), {
      children: [
        s && /* @__PURE__ */ i(
          R,
          m({
            visible: B,
            transitionProps: d && o ? { duration: 0 } : void 0
          }, u)
        ),
        /* @__PURE__ */ D(z, { __hidden: d && o && l ? o !== d.currentId : !1, children: [
          S && /* @__PURE__ */ D(F, { children: [
            r && /* @__PURE__ */ i(T, { children: r }),
            a && /* @__PURE__ */ i(O, m({}, n))
          ] }),
          /* @__PURE__ */ i(M, { children: p })
        ] })
      ]
    })
  );
});
h.classes = v;
h.displayName = "@mantine/core/Drawer";
h.Root = Z;
h.Overlay = R;
h.Content = z;
h.Body = M;
h.Header = F;
h.Title = T;
h.CloseButton = O;
h.Stack = q;
const Ae = "Drawer-module__root___vFdaU", Me = "Drawer-module__overlay___SFmaB", Oe = "Drawer-module__inner___9vZ6X", ze = "Drawer-module__content___64cRZ", Fe = "Drawer-module__headerSection___519PP", Re = "Drawer-module__title___77ung", Ze = "Drawer-module__description___UBfK4", Te = "Drawer-module__closeButton___n286r", He = "Drawer-module__body___VaoqR", Ee = "Drawer-module__footer___4-M3H", Ve = "Drawer-module__leftActions___IVCFk", je = "Drawer-module__rightActions___-t96V", w = {
  root: Ae,
  overlay: Me,
  inner: Oe,
  content: ze,
  headerSection: Fe,
  title: Re,
  description: Ze,
  closeButton: Te,
  body: He,
  footer: Ee,
  leftActions: Ve,
  rightActions: je
}, Ue = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780
}, Xe = J((N, S) => {
  var B = N, {
    "data-plum-id": t,
    closeButtonDataPlumId: e,
    opened: r,
    onClose: s,
    title: u,
    description: a,
    size: n = "md",
    position: p = "right",
    actions: l = [],
    children: o,
    className: c,
    classNames: y = {}
  } = B, d = _(B, [
    "data-plum-id",
    "closeButtonDataPlumId",
    "opened",
    "onClose",
    "title",
    "description",
    "size",
    "position",
    "actions",
    "children",
    "className",
    "classNames"
  ]);
  X(() => (r && (document.body.style.overflow = "hidden"), () => {
    document.body.style.overflow = "unset";
  }), [r]);
  const C = l.filter((f) => f.position === "left"), P = l.filter((f) => f.position !== "left");
  return /* @__PURE__ */ i(
    h,
    b(m({
      ref: S,
      opened: r,
      onClose: s,
      position: p,
      size: Ue[n],
      classNames: m({
        root: `${w.root} ${y.root || ""}`,
        overlay: `${w.overlay} ${y.overlay || ""}`,
        body: `${w.body} ${y.body || ""}`,
        header: `${w.header} ${y.header || ""}`
      }, y),
      withCloseButton: !1,
      "data-plum-id": t
    }, d), {
      children: /* @__PURE__ */ D("div", { className: w.inner, children: [
        /* @__PURE__ */ D("div", { className: w.content, children: [
          /* @__PURE__ */ D("div", { className: w.headerSection, children: [
            /* @__PURE__ */ D(we, { gap: "xs", w: "100%", children: [
              u && /* @__PURE__ */ i(L, { order: 4, className: w.title, children: u }),
              a && /* @__PURE__ */ i("p", { className: w.description, children: a })
            ] }),
            /* @__PURE__ */ i(
              H,
              {
                className: w.closeButton,
                onClick: s,
                variant: "tertiary",
                size: "sm",
                "data-plum-id": e,
                children: /* @__PURE__ */ i(Q, {})
              }
            )
          ] }),
          o
        ] }),
        l.length > 0 && /* @__PURE__ */ D("div", { className: w.footer, children: [
          /* @__PURE__ */ i("div", { className: w.leftActions, children: C.map((f, I) => /* @__PURE__ */ i(
            H,
            {
              onClick: f.onClick,
              variant: f.variant || "tertiary",
              "data-danger": f.danger,
              "data-plum-id": f["data-plum-id"],
              children: f.label
            },
            I
          )) }),
          /* @__PURE__ */ i("div", { className: w.rightActions, children: P.map((f, I) => /* @__PURE__ */ i(
            H,
            {
              onClick: f.onClick,
              variant: f.variant || (I === P.length - 1 ? "accent" : "primary"),
              "data-danger": f.danger,
              "data-plum-id": f["data-plum-id"],
              children: f.label
            },
            I
          )) })
        ] })
      ] })
    })
  );
});
Xe.displayName = "Drawer";
export {
  Xe as Drawer
};
